<mat-sidenav-container autosize class="sidenav-container">
    <mat-sidenav [disableClose]="true" mode="side" opened="true" class="mat-elevation-z2" [fixedInViewport]="true">
        <mat-nav-list>
            <div class="input-form">
                <div *ngIf="isInEditMode" class="reorder-div">
                    <button mat-icon-button (click)="goToReorder()">
                        <!-- <mat-icon class="reorder-icon"  matTooltip="{{'wiki.reorder.reorderTip.fullLabel' | translate}}" matTooltipPosition="right"> -->
                        <mat-icon class="reorder-icon"  matTooltip="{{'wiki.reorder.reorderTip.fullLabel' | translate}}" matTooltipPosition="right">
                            reorder
                        </mat-icon>
                    </button>
                </div>
                    <mat-expansion-panel class="mat-elevation-z0">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <form [formGroup]="findTextForm" (ngSubmit)="onSubmit()">
                                        <mat-form-field>
                                            <mat-label>{{'wiki.search.fullLabel' | translate}}</mat-label>
                                            <input matInput formControlName="textToFind" autocomplete="off" (click)="$event.stopPropagation()" > 
                                        </mat-form-field>
                                        <button mat-icon-button type="submit" mat-button (click)="$event.stopPropagation()"><mat-icon>search</mat-icon></button>
                                    </form>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <span>
                                <mat-checkbox class="right-side-checkbox" value="title" [(ngModel)]="titleBool" (change)="changeSearchTitle()">{{'wiki.searchTitle.fullLabel' | translate}}</mat-checkbox>
                                <mat-checkbox class="right-side-checkbox" value="content" [(ngModel)]="contentBool" (change)="changeSearchContent()">{{'wiki.searchContent.fullLabel' | translate}}</mat-checkbox>
                            </span>
                    </mat-expansion-panel>
            </div>
            <app-side-nav-tree></app-side-nav-tree>
        </mat-nav-list>
        <!-- <ngx-simplebar>
        </ngx-simplebar> -->
    </mat-sidenav>
    <mat-sidenav-content>
        <mat-toolbar>
            <mat-toolbar-row>
                <span>{{'wiki.title.fullLabel' | translate}}</span>
                <span class="spacer"></span>
                
                <div class="right-side-divs">
                    <div *ngIf="isBizzDev" class="provider-select">
                        <mat-form-field>
                            <mat-label>{{'wiki.selectedProvider.shortLabel' | translate}}</mat-label>
                            <mat-select [(ngModel)]="selectedProviderType" (ngModelChange)="providerChange()">
                                <mat-option [value]="providerType.sic">{{'wiki.providers.bdcsAndSic.shortLabel' | translate}}</mat-option>
                                <mat-option [value]="providerType.sicBxl">{{'wiki.providers.sicbxl.shortLabel' | translate}}</mat-option>
                                <mat-option [value]="providerType.bbc">{{'wiki.providers.bbc2020.shortLabel'| translate}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="print-button" *ngIf="selectedDirectoryOrFilePath"><button (click)="printToPdf()" mat-icon-button><mat-icon>picture_as_pdf</mat-icon></button></div>
                    <div class="slide-toggle-div" *ngIf="isBizzDev"><mat-slide-toggle [(ngModel)]="isInEditMode" (change)="changeEditMode($event)"><mat-label>{{'wiki.editor.edit.fullLabel' | translate}}</mat-label></mat-slide-toggle></div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>